import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";
import { logError } from "./logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => {
    const login = (usuario) => setUser(usuario);
    const logout = async () => {
      try {
        await api.post("/auth/logout");
      } catch (error) {
        logError("Error al cerrar sesión (la sesión local se limpia igual):", error);
      }
      setUser(null);
    };
    return { user, setUser, login, logout, loading, isAdmin: user?.rol === "admin",
      tienePermiso: (...claves) => user?.rol === "admin" ||
        claves.some((c) => (user?.permisos || []).includes(c)) };
  }, [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
